import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';

export const SmsEvent = styled.div((props: { own: boolean }) => css`
  display: flex;
  gap: ${sizes.xSmall};

  ${props.own && css`
    flex-direction: row-reverse;
    justify-content: end;
  `}
`);

export const SmsEventParticipant = styled.div`
  padding: 1.4rem 0;
`;

export const SmsEventContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};
  padding: ${sizes.xSmall};
  background: ${colors.gray1};
  border-radius: 6px;
  width: 65%;
`;

export const SmsEventSender = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${colors.gray4};
`;
